export default __webpack_public_path__ + "static/2616-2a5432b3d44e883d0c7159971e1fe327.jpg";